import { render, staticRenderFns } from "./DetallesNotario.vue?vue&type=template&id=ead21036&scoped=true"
import script from "./DetallesNotario.vue?vue&type=script&lang=js"
export * from "./DetallesNotario.vue?vue&type=script&lang=js"
import style0 from "./DetallesNotario.vue?vue&type=style&index=0&id=ead21036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead21036",
  null
  
)

export default component.exports